import { LazyModule, LazyAction, createLazyComponent } from 'owa-bundling';
export * from './publicSelectors';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "TimeStreamProjectManager" */ './lazyIndex')
);

export const openNewOutlookSpaceDialog = new LazyAction(
    lazyModule,
    m => m.openNewOutlookSpaceDialog
).importAndExecute;

export const openEditOutlookSpaceDialog = new LazyAction(
    lazyModule,
    m => m.openEditOutlookSpaceDialog
).importAndExecute;

export const cancelOutlookSpaceDialog = new LazyAction(lazyModule, m => m.cancelOutlookSpaceDialog)
    .importAndExecute;

export const closeProjectPreview = new LazyAction(lazyModule, m => m.closeProjectPreview)
    .importAndExecute;

export const selectTemplateFromPreview = new LazyAction(
    lazyModule,
    m => m.selectTemplateFromPreview
).importAndExecute;

export const ProjectManagerDialog = createLazyComponent(lazyModule, m => m.ProjectManagerDialog);
